module.exports = __webpack_public_path__ + "img/thumb_up.fea64c36.svg";